import { render, staticRenderFns } from "./warning-car.vue?vue&type=template&id=589864bb&scoped=true"
import script from "./warning-car.vue?vue&type=script&lang=js"
export * from "./warning-car.vue?vue&type=script&lang=js"
import style0 from "./warning-car.vue?vue&type=style&index=0&id=589864bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589864bb",
  null
  
)

export default component.exports